import { EndSessionWarningModalController } from '@app/components/modals/end-session-warning-modal/end-session-warning.modal-controller';
import { ActivityTrackerService } from '@app/services/activity-tracker/activity-tracker.service';
import { Component, OnInit } from '@angular/core';
import { FeatureFlagManagerService } from '@app/infrastructure/feature-flag-manager/feature-flag-manager.service';

@Component({
	selector: 'app-host',
	templateUrl: './host.component.html',
	styleUrls: ['./host.component.scss'],
	providers: [ActivityTrackerService],
})
export class HostComponent implements OnInit {
	constructor(
		private endSessionWarningModalController: EndSessionWarningModalController,
		private activityTracker: ActivityTrackerService,
		public featureFlagManagerService: FeatureFlagManagerService,
	) {}

	public ngOnInit() {
		this.endSessionWarningModalController.init();
		this.activityTracker.init();
	}
}
